import { useEffect } from "react";

/**
 * Injects a JSON-LD script into document head. Use for structured data (WebSite, Organization, etc.).
 */
const JsonLd = ({ data, id = "jsonld-data" }) => {
  useEffect(() => {
    if (!data) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    script.id = id;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data, id]);

  return null;
};

export default JsonLd;
